<!--送培第0步 报名信息-->
<template>
  <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-notice-bar 
  text="请填写真实可收件地址，以便后期邮寄培训班相关物料。"
/>
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-cell-group>
        <van-field
            v-model="formData.saiqu_name"
            label="场次"
            input-align="right"
            readonly
        />

        <van-field
            v-model="formData.danwei"
            label="单位"
            :rules="[{ required: true, message: '请输入单位名称' }]"
            error-message-align="right"
            input-align="right"
            placeholder="请输入单位名称"
        />
        <van-field
            v-model="formData.ldname"
            label="联系人"
            :rules="[{ required: true, message: '联系人不能为空' }]"
            error-message-align="right"
            input-align="right"
            clearable
            placeholder="请输入联系人姓名"
        />
        <van-field
            v-model="formData.num"
            label="身份证号"
            error-message-align="right"
            input-align="right"
            clearable
            placeholder="请输入身份证号"
        />

        <van-field
            v-if="false"
            v-model="formData.weixin"
            :rules="[{ required: true,message:'请输入微信号'}]"
            error-message-align="right"
            label="微信号"
            input-align="right"
            clearable
            placeholder="请输入微信号"
        />

        <van-field
            v-model="formData.phone"
            :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
            error-message-align="right"
            label="手机"
            input-align="right"
            clearable
            placeholder="请输入手机"
        />

        <van-field
            v-model="formData.email"
            :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
            error-message-align="right"
            label="邮箱"
            input-align="right"
            clearable
            placeholder="请输入邮箱"
        />

        <van-field
            readonly
            clickable
            name="area"
            :value="formData.county?(formData.province+'/'+formData.city+'/'+formData.county):''"
            input-align="right"
            label="收件地区选择"
            placeholder="点击选择省市区"
            @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>


        <van-field
            v-model="formData.address"
            :rules="[{ required: true, message: '请输入详细地址' }]"
            error-message-align="right"
            label="收件详细地址"
            input-align="right"
            clearable
            placeholder="请输入详细地址"
        />


      </van-cell-group>


      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">下一步
        </van-button>
      </div>
    </van-form>


    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SongpeiApplyFormStep1',
  components: {
    [Field.name]: Field,
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        areas: '',
        saiqu_name: '',
        danwei: '',
        ldname: '',
        weixin: '',
        phone: '',
        email: '',
        province: '',
        city: '',
        county: '',
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = '联系人信息';
    this.fetch();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    fetch() {
      let that = this;
      that.$api.get('/api/songpei/step1Detail', {
        saiqu_id: that.saiqu_id,
        id: that.formData.id,
      }, (res) => {
        that.formData = Object.assign(that.formData, res.data);

        console.log('Dialog');
        if (res.data.haveNoDone) {
          Dialog.setDefaultOptions({
            'confirmButtonText': '继续未完成的报名',
            'cancelButtonText': '重新报名',
          })
          Dialog.confirm({
            title: '您有未完成的报名',
            message: '建议您选择继续未完成的报名'
          }).then(() => {
            that.jumToOld();
          }).catch(() => {
          });
        }

      }, (res) => {

        console.log('没有登录');
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    onQuestion() {
      console.log('onQuestion')
    },
    jumToOld(id) {
      rbLink({
        name: 'SongpeiApplyList'
      }, 'replace')
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/songpei/baoming', that.formData, (res) => {
        that.saveLoading = false;

        // 补充人员信息
        rbLink({
          name: 'SongpeiApplyFormStep1',
          query: {
            id: res.data.id
          }
        })

        // rbLink({
        //     name:'SongpeiApplyFormStep2',
        //     query:{
        //         id: res.data.id
        //     }
        // },'replace')

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// SongpeiApplyFormBasic.vue?66217de0